var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"phone-link",class:{ dark: _vm.dark}},[_c('a',{attrs:{"href":"mailto:"+_vm.emailaddr}},[_vm._v(" "+_vm._s(_vm.emailaddr)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }